import * as yup from 'yup';

export interface EventFormValue {
  name: string;
  phone: string;
  email: string;
  policy: boolean;
}

export const eventFormSchema = yup.object().shape({
  name: yup.string().trim().required('Укажите имя'),
  phone: yup
    .string()
    .required('Укажите телефон')
    .test('phone-length', 'Телефон должен содержать 11 цифр', (value) => {
      const digits = (value ?? '').replace(/\D/g, '');
      return digits.length === 11;
    }),
  email: yup
    .string()
    .email('Укажите корректный e-mail')
    .required('Укажите e-mail'),
  policy: yup
    .mixed()
    .test(
      'is-true',
      'Необходимо согласие с политикой конфиденциальности',
      (value) => value === true || value === 'on',
    ),
});
